import { render, staticRenderFns } from "./delivery-detail.vue?vue&type=template&id=f4edbf56&scoped=true&"
import script from "./delivery-detail.vue?vue&type=script&lang=js&"
export * from "./delivery-detail.vue?vue&type=script&lang=js&"
import style0 from "./delivery-detail.sass?vue&type=style&index=0&id=f4edbf56&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4edbf56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/goeatBackup/goeat-backup-goeat-order-line/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VBtn,VCarousel,VCarouselItem,VContainer,VFlex,VIcon,VLayout,VProgressCircular})
